"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyEmployeePhoto;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const react_native_2 = require("react-native");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const Button_1 = __importDefault(require("../components/Button"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const Employees_1 = __importDefault(require("../api/Employees"));
const FileUpload_1 = __importDefault(require("../components/FileUpload"));
function CompanyEmployeePhotoHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.SquareUser, size: 28, color: THEME.Primary }), (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flex: 1, gap: 2, marginLeft: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { "aria-label": props['aria-label'], style: { color: THEME.Text, fontWeight: '500', fontSize: size != 'sm' ? 18 : 16 }, children: props.text }), !!props.subText && (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12 }, children: props.subText })] }), (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: 'borderless', onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
function CompanyEmployeePhoto(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const viewSize = (() => {
        let s = 360;
        let w = react_native_1.Dimensions.get('window').width;
        if (w - 36 < s)
            s = w - 36;
        return s;
    })();
    const viewRef = react_1.default.useRef(null);
    const canvasRef = react_1.default.useRef(null);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [existing, setExisting] = react_1.default.useState(null);
    const [photoFile, setPhotoFile] = react_1.default.useState(null);
    const [photoSize, setPhotoSize] = react_1.default.useState(null);
    const [finalSize, setFinalSize] = react_1.default.useState(1024);
    const startX = react_1.default.useRef(0);
    const startY = react_1.default.useRef(0);
    const latestX = react_1.default.useRef(0);
    const latestY = react_1.default.useRef(0);
    const translateX = react_1.default.useRef(new react_native_1.Animated.Value(0)).current;
    const translateY = react_1.default.useRef(new react_native_1.Animated.Value(0)).current;
    const startScale = react_1.default.useRef(1);
    const latestScale = react_1.default.useRef(1);
    const scale = react_1.default.useRef(new react_native_1.Animated.Value(1)).current;
    react_1.default.useEffect(() => {
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Employees_1.default.getPhoto(token, props.route.params.employeeId))).then((data) => {
            setExisting(data);
            setStatus('done');
        }).catch((e) => {
            console.log(e);
            setStatus('error');
        });
    }, []);
    react_1.default.useEffect(() => {
        if (!photoFile)
            return;
        if (react_native_1.Platform.OS != 'web')
            return;
        latestScale.current = 1;
        latestX.current = 0;
        latestY.current = 0;
        scale.setValue(latestScale.current);
        translateX.setValue(latestX.current);
        translateY.setValue(latestY.current);
        let img = new globalThis.Image();
        img.onload = () => {
            setPhotoSize({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
            URL.revokeObjectURL(img.src);
        };
        img.src = URL.createObjectURL(photoFile);
    }, [photoFile]);
    react_1.default.useEffect(() => {
        if (!photoSize)
            return;
        let s = Math.min(photoSize.width, photoSize.height);
        if (s > 1024)
            s = 1024;
        setFinalSize(s);
    }, [photoSize]);
    react_1.default.useEffect(() => {
        if (react_native_1.Platform.OS != 'web')
            return;
        viewRef.current.addEventListener('wheel', function (event) {
            let rate = (Math.abs(event.deltaY) > 10 ? 1.1 : 1.01);
            let factor = (event.deltaY < 0 ? rate : 1 / rate);
            latestScale.current = latestScale.current * factor;
            scale.setValue(latestScale.current);
        });
    }, []);
    const resizePhotoWeb = () => {
        if (photoFile && canvasRef.current) {
            let ctx = canvasRef.current.getContext('2d');
            ctx.fillStyle = '#000000';
            ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            return new Promise((resolve, reject) => {
                let img = new globalThis.Image();
                img.onload = () => {
                    ctx.drawImage(img, (photoSize.width / 2) - (viewSize / latestScale.current / 2) - latestX.current, (photoSize.height / 2) - (viewSize / latestScale.current / 2) - latestY.current, viewSize / latestScale.current, viewSize / latestScale.current, 0, 0, finalSize, finalSize);
                    resolve();
                };
                img.src = URL.createObjectURL(photoFile);
            });
        }
        else {
            return Promise.reject();
        }
    };
    const uploadPhoto = () => {
        setStatus('saving');
        let prepare = null;
        if (photoFile) {
            if (react_native_1.Platform.OS == 'web') {
                prepare = resizePhotoWeb().then(() => canvasRef?.current.toDataURL("image/jpeg").split(';base64,')[1]);
            }
            else {
                prepare = Promise.resolve(photoFile.data);
            }
        }
        else if (existing?.photo) {
            prepare = Promise.resolve(null);
        }
        prepare.then((base64) => {
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Employees_1.default.uploadPhoto(token, props.route.params.employeeId, { type: 'image/jpeg', data: base64 }))).then(() => {
                if (react_native_1.Platform.OS == 'web') {
                    react_native_1.DeviceEventEmitter.emit('event.employeePhotoUpload');
                    props.navigation.goBack();
                }
                else {
                    props.navigation.goBack();
                }
            }).catch((e) => {
                console.log(e);
                setStatus('error');
            });
        });
    };
    const pinch = react_native_gesture_handler_1.Gesture.Pinch()
        .enabled(!!photoFile && react_native_1.Platform.OS == 'web')
        .onStart(() => {
        startScale.current = latestScale.current;
    })
        .onUpdate((e) => {
        if (e.numberOfPointers != 2)
            return;
        latestScale.current = startScale.current * e.scale;
        scale.setValue(latestScale.current);
    })
        .runOnJS(true);
    const pan = react_native_gesture_handler_1.Gesture.Pan()
        .enabled(!!photoFile && react_native_1.Platform.OS == 'web')
        .minDistance(10)
        .onStart(() => {
        startX.current = latestX.current;
        startY.current = latestY.current;
    })
        .onUpdate((e) => {
        latestX.current = startX.current + (e.translationX * (1 / latestScale.current));
        latestY.current = startY.current + (e.translationY * (1 / latestScale.current));
        translateX.setValue(latestX.current);
        translateY.setValue(latestY.current);
    })
        .runOnJS(true);
    const animatedStyle = react_1.default.useMemo(() => ({
        transformOrigin: 'center',
        transform: [
            { scale },
            { translateX },
            { translateY },
        ]
    }), [scale, translateX, translateY]);
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, width: 480, children: [(0, jsx_runtime_1.jsx)(react_native_2.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 8, marginBottom: 8 }, children: (0, jsx_runtime_1.jsx)(CompanyEmployeePhotoHeader, { "aria-label": t('common:screenTitles.eeBenefitDetails'), text: t('company:labels.uploadPhoto'), subText: existing?.fullName, onClose: props.navigation.goBack }) }), (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureHandlerRootView, { children: (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.GestureDetector, { gesture: react_native_gesture_handler_1.Gesture.Simultaneous(pan, pinch), children: (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                            alignSelf: 'center',
                            position: 'relative',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            cursor: (photoFile && 'move'),
                            borderWidth: 4,
                            borderColor: (status == 'loading' ? THEME.CardBorder : THEME.Primary),
                            backgroundColor: (status == 'loading' ? null : THEME.UltraLightGray),
                        }, children: (0, jsx_runtime_1.jsx)(react_native_2.View, { ref: viewRef, style: {
                                width: viewSize,
                                height: viewSize,
                                alignItems: 'center',
                                justifyContent: 'center',
                                overflow: 'hidden'
                            }, children: (status == 'loading' || status == 'error')
                                &&
                                    (0, jsx_runtime_1.jsx)(Loading_1.default, { size: 48, loading: status == 'loading', error: status == 'error' })
                                ||
                                    // @ts-ignore
                                    (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: photoFile && [animatedStyle], children: photoFile
                                            &&
                                                (0, jsx_runtime_1.jsx)(react_native_2.Image, { resizeMode: "stretch", source: { uri: react_native_1.Platform.OS == 'web' ? URL.createObjectURL(photoFile) : photoFile.path }, style: {
                                                        width: react_native_1.Platform.OS == 'web' ? photoSize?.width : viewSize,
                                                        height: react_native_1.Platform.OS == 'web' ? photoSize?.height : viewSize
                                                    } })
                                            ||
                                                (existing?.photo
                                                    &&
                                                        (0, jsx_runtime_1.jsx)(react_native_2.Image, { resizeMode: "stretch", style: { width: viewSize, height: viewSize }, source: { uri: `data:image/unknown;base64,${existing?.photo}` } })
                                                    ||
                                                        (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.CardBorder, size: 128, icon: Theme_1.ICONS.DuoTone.SquareUser })) }) }) }) }) }), (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { marginTop: 14, marginBottom: 6, alignItems: 'center', justifyContent: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_2.View, { style: { marginVertical: 6 }, children: (0, jsx_runtime_1.jsxs)(react_native_2.Text, { style: { color: THEME.Text }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { fontWeight: '500' }, children: "Step 1" }), " \u2013 ", t('company:text.employeePhotoSelect')] }) }), (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { marginVertical: 6 }, children: (0, jsx_runtime_1.jsxs)(react_native_2.Text, { style: { color: THEME.Text }, children: [(0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { fontWeight: '500' }, children: "Step 2" }), " \u2013 ", t('company:text.employeePhotoZoomDrag')] }) })] }), (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', gap: 12, padding: 12, alignItems: 'center' }, children: [react_native_1.Platform.OS == 'web'
                        &&
                            (0, jsx_runtime_1.jsx)(FileUpload_1.default, { disabled: status == 'loading' || status == 'saving', buttonText: t('company:buttons.selectPhoto'), waitingText: t('common:text.pleaseWait'), extensions: ['jpg', 'jpeg', 'png', 'webp'], mimeTypes: ['image/jpeg', 'image/png'], getUploadUrl: props.getUploadUrl, onFileSelected: (f) => setPhotoFile(f), style: { flex: 1 } })
                        ||
                            (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: status == 'loading' || status == 'saving', style: { flex: 1 }, onPress: () => {
                                    const ImagePicker = require('react-native-image-crop-picker');
                                    ImagePicker.openPicker({
                                        mediaType: 'photo',
                                        width: finalSize,
                                        height: finalSize,
                                        cropping: true,
                                        forceJpg: true,
                                        writeTempFile: false,
                                        includeBase64: true
                                    }).then((image) => {
                                        setPhotoFile(image);
                                    });
                                }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: '#ffffff', fontSize: 16, fontWeight: '500' }, children: t('company:buttons.selectPhoto') }) }), (photoFile || !existing?.photo) &&
                        (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: photoFile == null || status == 'saving', color: THEME.Secondary, onPress: uploadPhoto, style: { flex: 1 }, children: status == 'saving'
                                &&
                                    (0, jsx_runtime_1.jsx)(react_native_2.ActivityIndicator, { color: "#ffffff", size: 20 })
                                ||
                                    (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: '#ffffff', fontSize: 16, fontWeight: '500' }, children: t('common:buttons.save') }) }), (existing?.photo && !photoFile) &&
                        (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: status == 'saving', color: THEME.Red, onPress: () => uploadPhoto(), style: { flex: 1 }, children: status == 'saving'
                                &&
                                    (0, jsx_runtime_1.jsx)(react_native_2.ActivityIndicator, { color: "#ffffff", size: 20 })
                                ||
                                    (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: '#ffffff', fontSize: 16, fontWeight: '500' }, children: t('common:buttons.remove') }) })] }), react_native_1.Platform.OS == 'web' &&
                (0, jsx_runtime_1.jsx)("canvas", { ref: canvasRef, width: finalSize, height: finalSize, style: {
                        display: 'none',
                        borderWidth: 4,
                        borderColor: THEME.CardBorder,
                        borderStyle: 'solid',
                        width: viewSize,
                        height: viewSize
                    } })] }));
}
